import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";

export const InsufficientCreditScore = () => {
  return (
    <span className="text-3xl font-bold text-content-1000 flex items-start gap-1">
      N/A
      <Tooltip placement="bottom-start">
        <TooltipTrigger>
          <HugeiconsIcon
            icon={InformationCircleIcon}
            className="text-alpha-300 w-4 h-4 mt-1.5"
          />
        </TooltipTrigger>
        <TooltipContent className="bg-alpha-800 rounded-lg border p-4 text-sm text-white max-w-96">
          The consumer has a &quot;Hit&quot; (we found their file), but there is
          insufficient credit history to generate a score
        </TooltipContent>
      </Tooltip>
    </span>
  );
};
